import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { getCompliancePermissions } from 'src/app/compliance/store/actions/compliance.actions';

@Injectable({
    providedIn: 'root'
})
export class ComplianceGuard {
    constructor(private readonly _store: Store) {}

    canLoad(): boolean {
        this._store.dispatch(getCompliancePermissions());
        return true;
    }
}
